export enum AnnexedParamFormMode {
  NULL = 'null',
  WITHDRAWAL = 'withdrawal',
  INCIDENT_REPLY = 'incidentReply',
  SEND_CLAIM_INFORMATION = 'informationType',
  REINSTATEMENT = 'reinstatement',
  SEND_REINSTATEMENT_REPLY = 'reinstatementReply',
  CANCELLATION = 'cancellation'
}
